import React from 'react'
import { Result, Button } from 'antd'

import { ErrorWrapper } from './style'

const ErrorView = () => {
  return (
    <ErrorWrapper>
      <Result
        status="403"
        title="Hang in there"
        subTitle="You may be experiencing weak or no internet connection. Please check. Refresh your page in sometime. Thank you for your patience."
        extra={
          <Button onClick={() => window.location.reload()} type="primary">
            Refresh
          </Button>
        }
      />
    </ErrorWrapper>
  )
}

export default ErrorView
